import PropTypes from "prop-types"

import Button from "components/ui/button"
import { cn } from "styles/utils"

export const ActionBtn = ({ className = "", ...props }) => (
  <Button
    className={cn("text-14 mx-16 font-medium tracking-normal", className)}
    text
    underline
    variant="secondary"
    {...props}
  />
)

ActionBtn.propTypes = {
  className: PropTypes.string,
}

export const Text = ({
  className = "",
  cutoffStyle = false,
  holidayStyle = false,
  pdpPricingHierarchyExp,
  second = false,
  ...props
}) => (
  <p
    className={cn(
      pdpPricingHierarchyExp
        ? "text-14 tracking-tigher leading-16 mb-6 text-black"
        : cn(
            "text-14 tracking-tigher leading-16 text-black-print mb-6",
            !holidayStyle && !cutoffStyle && "tablet:text-neutral",
            holidayStyle &&
              (second
                ? "leading-30 tablet:text-black tablet:leading-16"
                : "rounded-4xl text-sale tablet:bg-transparent tablet:rounded-none tablet:mb-6 tablet:p-0 mb-0 inline-block bg-[#FCF2F2] px-16 py-10"),
            cutoffStyle && (second ? "text-black-print" : "text-sale font-bold")
          ),
      className
    )}
    {...props}
  />
)

Text.propTypes = {
  className: PropTypes.string,
  cutoffStyle: PropTypes.bool,
  holidayStyle: PropTypes.bool,
  pdpPricingHierarchyExp: PropTypes.bool,
  second: PropTypes.bool,
}

export const ShipDate = ({
  className = "",
  cutoffStyle = false,
  holidayStyle = false,
  pdpPricingHierarchyExp,
  second = false,
  ...props
}) => (
  <span
    className={cn(
      pdpPricingHierarchyExp
        ? cn(
            "text-14 tracking-tigher leading-16 font-semibold text-black",
            holidayStyle && "text-sale-pink"
          )
        : cn(
            "text-14 tracking-tigher leading-16 mb-4",
            holidayStyle || cutoffStyle ? "font-bold" : "text-green-darker",
            cutoffStyle && (second ? "text-black-print" : "text-sale")
          ),
      className
    )}
    {...props}
  />
)

ShipDate.propTypes = {
  className: PropTypes.string,
  cutoffStyle: PropTypes.bool,
  holidayStyle: PropTypes.bool,
  pdpPricingHierarchyExp: PropTypes.bool,
  second: PropTypes.bool,
}
